import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiSeriesType } from '@euler/model/bi/viz';
import { memo } from 'react';
import { View } from 'react-native';

export interface BiLegendItem {
  name: string;
  color: string;
  /** A line series shows a stroke, anything else a dot. */
  type?: BiSeriesType;
  /** e.g. `右轴`, the slice's value. */
  note?: string;
}

/**
 * The chart's legend: a wrapping row centred under (or over) the plot, or
 * a column on the right.
 */
export const BiChartLegend = memo(
  ({ items, vertical }: { items: BiLegendItem[]; vertical?: boolean }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={
          vertical
            ? { gap: rpx(6), maxWidth: '40%' }
            : {
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: rpx(12),
              }
        }
      >
        {items.map((item, i) => (
          <View
            key={`${item.name}-${i}`}
            style={{ flexDirection: 'row', alignItems: 'center', gap: rpx(4) }}
          >
            <View
              style={
                item.type === BiSeriesType.Line
                  ? {
                      width: rpx(12),
                      height: rpx(2),
                      borderRadius: rpx(1),
                      backgroundColor: item.color,
                    }
                  : {
                      width: rpx(8),
                      height: rpx(8),
                      borderRadius: rpx(4),
                      backgroundColor: item.color,
                    }
              }
            />
            <Typography.Text
              size={rpx(11)}
              color={aiColors.mutedForeground}
              numberOfLines={vertical ? 2 : 1}
              style={{ flexShrink: 1 }}
            >
              {item.note ? `${item.name}（${item.note}）` : item.name}
            </Typography.Text>
          </View>
        ))}
      </View>
    );
  },
);
